import React, { Component } from 'react';
import styled from 'styled-components'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { PageContainer, Header, PageTitle, TextBox, TextBlock, BottomButtons, Button } from '../components/styledComponents'

const TimerContainer = styled.div`
	padding: 80px;
	margin-top: 20px;
`

export default class Contemplate extends Component {
	state = {
		running: false,
		value: 0
	}
	componentDidMount() {
		this.audio = new Audio('audio/bell.wav')
	}

	startTimer() {
		if (!this.state.running) {
			this.setState({ running: true })
			this.timer = setInterval(() => {
				if (this.state.value < 60) {
					this.setState({ value: this.state.value+1 })
				} else {
					this.timerFinished()
				}
			}, 1000)
		} else {
			clearInterval(this.timer)
			this.setState({ running: false })
		}
	}
	playBell() {
		this.audio.play()
	}
	timerFinished() {
		this.playBell()
		clearInterval(this.timer)
		this.setState({ running: false })
		this.props.onProceed()
	}

	render() {
		const { running, value } = this.state
		return (
			<PageContainer>

        <TextBlock>

        	<span>Meditation gives you room to breathe and think</span><br/>
        	<span>Take one minute to think about the question</span><br/>
        	<span>When you're ready, click start</span><br/>
       	</TextBlock>
       	<TextBox>
       		<TextBlock style={{ textAlign: 'center' }}><b>{this.props.question.q}</b></TextBlock>
       	</TextBox>
        <TimerContainer>{running && <CircularProgressbar
					value={value*1.67}
					text={!running ? '60s' : value}
					background
	        backgroundPadding={6}
	        styles={buildStyles({
	          backgroundColor: "rgb(126, 69, 62)",
	          textColor: "#fff",
	          pathColor: "#fff",
	          trailColor: "transparent"
	        })}
				/>}
				</TimerContainer>
				<BottomButtons>
					<Button
						onClick={this.startTimer.bind(this)}
					>
						{!running ? 'Start Meditation' : 'Pause '}
					</Button>
				</BottomButtons>
			</PageContainer>
		)
	}

}
